export class DateTimeUtils {

    /**
     * @constructor
     */
    static get UTCNow(): number {
        return Date.now();
    }

    static getISODateTime(): string {
        return DateTimeUtils.toISOString(new Date());
    }

    /**
     * cross-browser implementation of toISO string, using this because
     * IE's Date.toUTCString() produces a non standard format (UTC at the end instead of GMT)
     * @param date
     */
    static toISOString(date: Date): string {
        const day: string = date.getUTCDate().toString().padStart(2, '0');
        const month: string = (date.getUTCMonth() + 1).toString().padStart(2, '0');
        const year: string = date.getUTCFullYear().toString();

        const hour: string = date.getUTCHours().toString().padStart(2, '0');
        const minutes: string = date.getUTCMinutes().toString().padStart(2, '0');
        const seconds: string = date.getUTCSeconds().toString().padStart(2, '0');
        const millis: number = date.getUTCMilliseconds();

        const strDate: string = [year, month, day].join('-');
        const strTime: string = [hour, minutes, seconds].join(':');
        return `${strDate}T${strTime}.${millis}Z`;
    }

    static getTimestamp(): number {
        return DateTimeUtils.UTCNow;
    }
}
